export default {
  props:['data'],
  data(){
    return {
      state:{
        companyId:null,
      },
      checked:[]
    }
  },
  created(){
    this.checked = this.data.map(i => i.carNo)
  },
  computed:{
    tip(){
      return `共${this.checked.length}项 转移至`
    }
  },
  methods:{
    renderOptions(){
      const data = this.data || []
      return data.map(i => <Checkbox style="flex-basis:50%;" label={i.carNo}>
        <div>
          <div>
            <span style="font-size:13px;color:rgba(0,0,0,.65);">No.{i.carNo}</span>
            { i.license ? <span title="车牌号" style="border: 1px solid rgba(0,0,0,.3);color:#333;padding: 2px 5px;font-size:9px;border-radius:2px;margin-left:5px;">{i.license}</span> : null }
          </div>
          <p style="margin-top:3px;font-size:11px;color:rgba(0,0,0,.4);">
            <Icon style={{'marginRight':'5px'}} custom="i-icon icon-company" />
            <span>{i.companyName}</span>
          </p>
        </div>
      </Checkbox>)
    },

    smsConfirm(params){
      this.$sms({  
        title: '信息验证' , 
        api:'carPushConfirm',
        beforeClose:(resp) => {
          if(resp.code){
            this.$Modal.error({ title:'转移失败',content: resp.msg })
            return false
          }
        },
        params(state){
          return {...params , ...state}
        }
      }).then(resp => {
        this.$Message.success({ content: '转移成功' })
        this.$emit('ok')
      })
    },
    save(){
      if( this.checked.length == 0 ){
        this.$Message.error({ content: '请选择待转移车辆' })
        return
      }
      if( !this.state.companyId ){
        this.$Message.error({ content: '请选择车辆转入企业' })
        return
      }
      const params = { carNos: this.checked , companyId: this.state.companyId }
      this.loading = true
      this.$request.carPush(params).then(resp => {
        if (resp.code == 0){
          this.$Message.success({ content: '转移成功' })
          this.$emit('ok')
        } else if(resp.code == 292035){
          this.smsConfirm(params)
        } else {
          this.$Modal.error({ title:'转移失败',content: resp.msg })
        }
        this.loading = false
      })
      // this.$sms({
      //   title: '信息验证',params, api:'companyExport'
      // })
    }
  },
  render(){
    return (
      <div>
        <div class="modal-body">
          <div style="height:230px;overflow-y:auto;border:1px solid rgba(0,0,0,.08);">
            <CheckboxGroup class="sl-checkbox-flex" size="large" v-model={this.checked}>
              {this.renderOptions()}
            </CheckboxGroup>
          </div>
          <div style="text-align:center;margin:16px auto;">
            <Icon style={{'fontSize':'25px'}} custom="i-icon icon-push-down" />
          </div>
          <div style="margin:0 20% 16px;" class="flex">
            <span style="flex:none;font-size:13px;margin-right:8px;color:rgba(0,0,0,.65);">{this.tip}</span>
            <sl-select v-model={this.state.companyId} dict="company" filterable={true} />
          </div>
        </div>
        <div class="modal-footer">
          <Button on-click={this.save} loading={this.loading} type="primary">确定转移</Button>
        </div>
      </div>
    )
  }
}